import { useQuery } from '@tanstack/react-query'
import { getActiveIncident } from '../api/sessions'
import type { IncidentResponse } from '../types'

export const ACTIVE_INCIDENT_KEY = ['activeIncident']

/**
 * Polls GET /api/v1/incidents/active every 30 seconds.
 * Shared React Query cache — no duplicate requests regardless of how many
 * components subscribe.
 */
export function useActiveIncident() {
  return useQuery<IncidentResponse | null>({
    queryKey: ACTIVE_INCIDENT_KEY,
    queryFn: getActiveIncident,
    refetchInterval: 30_000,
    staleTime: 0,
  })
}
